import { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { AuthContext } from './context/AuthProvider';

import Login from './components/Pages/Auth/Login';
import Home from './components/Pages/Home/Home';
import NotFound from './components/Pages/NotFound/NotFound';
import Menu from './components/Menu/Menu';
import Reports from './components/Pages/Reports/Reports';
import ForgotPassword from './components/Pages/Auth/ForgotPassword';
import Users from './components/Pages/Users/Users';
import UserConsumptions from './components/UserConsumptions/UserConsumptions';



function App() {
  const { isAuth, user } = useContext(AuthContext);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />

        {!isAuth ? (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path='reset-password' element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : (
          <Menu>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reports" element={<Reports/>} />
              {user?.isSuperuser && <>
                <Route path='/users' element={<Users />}/>
                <Route path='/consumptions' element={<UserConsumptions />}/>
                <Route path='/consumptions/:userId' element={<UserConsumptions />}/>
              </>}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Menu>
        )}
      </LocalizationProvider>
    </>
  );
}

export default App